// export const passwordRegex =
//   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
export const loginUsernameRegex = /^[a-zA-Z0-9._]+$/;
export const loginPasswordRegex = /^[\x21-\x7E]+$/;
export const passwordRegex = /^[a-zA-Z0-9]*$/;
export const usernameRegex = /^(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._@]+(?<![_.])$/;
export const latinCharsRegex = /^[a-zA-Z0-9]*$/;
export const persianCharsRegex = /^[ا-ی]$/;
export const farsiCharsRegex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s]+$/;
export const phoneNumberRegex =
  /(0|\+98)?([ \-()]*)9[0-5]([ \-()]*)\d([ \-()]*)\d([ \-()]*)\d([ \-()]*)\d([ \-()]*)\d([ \-()]*)\d([ \-()]*)\d([ \-()]*)\d/gi;
export const postalCodeRegex = /^[0-9]{11}$/;
export const seperateNumberRegex = /\B(?=(\d{3})+(?!\d))/g;
export const mobileNumberRegx = /^(?:(?:(?:\\+?|00)(98))|(0))?((?:90|91|92|93|99)[0-9]{8})$/;
export const hourNumberRegex = /^(2[0-4]|1[0-9]|[1-9])$/;
export const iranianPlateRegex = /^\d{2}[بپتثجچحخدذرزسشصطعفقکلمنوهی]\d{3}$/;
export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const addressRegex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF0-9۰-۹\s!@#$%^&*()_\-+=\[\]{};:'",.<>\/؟\\|`~]*$/;
export const englishAndSymbolsRegex = /^[a-zA-Z\s!@#$%^&*()_\-+=\[\]{};:'",.<>\/?\\|`~]*$/;